import React from 'react';
import classes from './styles.module.scss';

const ContentHeading = ({ text }) => {
  return <h3 className={classes.text}>{text}</h3>;
};

export default ContentHeading;
